import 'core-js/es6/string';
import 'core-js/es6/array';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/object';
import 'core-js/es6/promise';
import 'core-js/es7/object';
import 'core-js/es7/array';
import 'raf/polyfill';
import React from 'react';
import * as Sentry from '@sentry/browser';
import App from './App';
import { createRoot } from 'react-dom/client';

import './i18n';
import { updateTheme } from './_store/middlewares/theme.middleware';
import { updateClasses } from './_store/middlewares/settings.middleware';
import useSettingsStore from './stores/settingsStore';

// Sentry initialization
Sentry.init({
  dsn: 'https://9a0be961d2a4461fb12be0d3213d65eb@sentry.io/1732313',
});

// Read persisted settings from Zustand's storage and apply theme before rendering
const settings = useSettingsStore.getState().settings;
if (settings && settings.theme) {
  updateTheme(settings.theme);
}

// Apply all other settings (body/layout classes, etc.)
if (settings) {
  updateClasses({ settings: settings });
}

function reactApp() {
  const root = createRoot(document.getElementById('app'));
  root.render(<App />);
}

// Directly render the app
reactApp();
